import { connect } from 'react-redux';
import { FILE_TYPE_MANUSCRIPT } from '../constants';
import Files from './Files';
var mapStateToProps = function mapStateToProps(_ref, _ref2) {
  var serviceDetails = _ref.serviceDetails;
  var _ref2$excludedFileTyp = _ref2.excludedFileTypes,
    excludedFileTypes = _ref2$excludedFileTyp === void 0 ? [] : _ref2$excludedFileTyp,
    _ref2$alertsForTypes = _ref2.alertsForTypes,
    alertsForTypes = _ref2$alertsForTypes === void 0 ? {} : _ref2$alertsForTypes,
    _ref2$disabled = _ref2.disabled,
    disabled = _ref2$disabled === void 0 ? false : _ref2$disabled,
    serviceIdentities = _ref2.serviceIdentities,
    methods = _ref2.methods;
  return {
    alertsForTypes: alertsForTypes,
    disabled: disabled,
    fileTypes: serviceDetails.fileTypes.sort(function (a) {
      return a === FILE_TYPE_MANUSCRIPT ? -1 : 1;
    }),
    serviceIdentities: serviceIdentities,
    status: serviceDetails.status,
    excludedFileTypes: excludedFileTypes,
    methods: methods
  };
};
export default connect(mapStateToProps)(Files);